import {
  ArrowBackIcon,
  ArrowDownIcon,
  ArrowForwardIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpDownIcon,
  ArrowUpIcon,
  AtSignIcon,
  AttachmentIcon,
  BellIcon,
  CalendarIcon,
  ChatIcon,
  CheckCircleIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  CloseIcon,
  CopyIcon,
  DownloadIcon,
  DragHandleIcon,
  EditIcon,
  EmailIcon,
  ExternalLinkIcon,
  HamburgerIcon,
  InfoIcon,
  InfoOutlineIcon,
  LinkIcon,
  LockIcon,
  MinusIcon,
  MoonIcon,
  NotAllowedIcon,
  PhoneIcon,
  PlusSquareIcon,
  QuestionIcon,
  QuestionOutlineIcon,
  RepeatClockIcon,
  RepeatIcon,
  Search2Icon,
  SearchIcon,
  SettingsIcon,
  SmallAddIcon,
  SmallCloseIcon,
  SpinnerIcon,
  StarIcon,
  SunIcon,
  TimeIcon,
  TriangleDownIcon,
  TriangleUpIcon,
  UnlockIcon,
  UpDownIcon,
  ViewIcon,
  ViewOffIcon,
  WarningIcon,
  WarningTwoIcon,
} from '@chakra-ui/icons';
import { ReactNode } from 'react';

import { CoreIcons } from '@types';

export const coreIcons: Record<CoreIcons, ReactNode> = {
  'arrow-forward': ArrowForwardIcon,
  'arrow-up': ArrowUpIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-back': ArrowBackIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  'at-sign': AtSignIcon,
  calendar: CalendarIcon,
  chat: ChatIcon,
  'check-circle': CheckCircleIcon,
  'chevron-right': ChevronRightIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-up': ChevronUpIcon,
  copy: CopyIcon,
  download: DownloadIcon,
  hamburger: HamburgerIcon,
  moon: MoonIcon,
  lock: LockIcon,
  unlock: UnlockIcon,
  view: ViewIcon,
  'view-off': ViewOffIcon,
  repeat: RepeatIcon,
  'repeat-clock': RepeatClockIcon,
  edit: EditIcon,
  'external-link': ExternalLinkIcon,
  link: LinkIcon,
  'plus-square': PlusSquareIcon,
  time: TimeIcon,
  attachment: AttachmentIcon,
  'up-down': UpDownIcon,
  search: SearchIcon,
  'search-2': Search2Icon,
  settings: SettingsIcon,
  'small-add': SmallAddIcon,
  star: StarIcon,
  sun: SunIcon,
  email: EmailIcon,
  phone: PhoneIcon,
  spinner: SpinnerIcon,
  'drag-handle': DragHandleIcon,
  close: CloseIcon,
  'small-close': SmallCloseIcon,
  'not-allowed': NotAllowedIcon,
  'triangle-down': TriangleDownIcon,
  'triangle-up': TriangleUpIcon,
  bell: BellIcon,
  'info-outline': InfoOutlineIcon,
  info: InfoIcon,
  question: QuestionIcon,
  'question-outline': QuestionOutlineIcon,
  warning: WarningIcon,
  'warning-2': WarningTwoIcon,
  'arrow-up-down': ArrowUpDownIcon,
  check: CheckIcon,
  minus: MinusIcon,
};
